import { tenantConfig } from '../config/tenant'
import { COMPANY_SOCIALS } from '../data/team'

/**
 * schema.org JSON-LD for the business — a strong local-SEO signal (name, logo,
 * address, phone, socials, area served). Rendered on the Home + About pages and
 * captured by the SSG prerender, so search engines see it in the static HTML.
 * No aggregateRating here (Google requires a first-party, on-page review source;
 * our reviews are shown via a third-party widget, so we don't claim a rating).
 */
const LD = {
  '@context': 'https://schema.org',
  '@type': 'FinancialService',
  '@id': `${tenantConfig.siteUrl}/#organization`,
  name: tenantConfig.name,
  url: tenantConfig.siteUrl,
  logo: `${tenantConfig.siteUrl}${tenantConfig.logoImageUrl}`,
  image: `${tenantConfig.siteUrl}${tenantConfig.logoImageUrl}`,
  description:
    'Australian mortgage and finance brokers helping first home buyers, investors and business owners compare 60+ lenders and structure their finances strategically.',
  telephone: '+61 3 9191 0274',
  email: 'enquiries@greystonefinance.com.au',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '811/1 Queens Road',
    addressLocality: 'Melbourne',
    addressRegion: 'VIC',
    postalCode: '3004',
    addressCountry: 'AU',
  },
  areaServed: { '@type': 'Country', name: 'Australia' },
  priceRange: 'Free consultation',
  sameAs: [COMPANY_SOCIALS.linkedin, COMPANY_SOCIALS.facebook, COMPANY_SOCIALS.instagram].filter(Boolean),
}

export default function StructuredData() {
  return (
    <script
      type="application/ld+json"
      // JSON is safe to inline; type is not executable JS.
      dangerouslySetInnerHTML={{ __html: JSON.stringify(LD) }}
    />
  )
}
